export default "__VITE_ASSET__3Wgx69Fk__"